import Store from '@/store'
import {setStoreState} from '../../utils'
const categoryActions = {
  async setHotCategory(context, hotCategory): Promise<any> {
    try {
      setStoreState('category', 'hotCategory', hotCategory)
      localStorage.setItem('hotCategory', JSON.stringify(hotCategory))
    } catch (error: any) {
      console.log(error)
      throw error
    }
  },
}

type categoryActionsType = typeof categoryActions

export {categoryActionsType}
export default categoryActions
